export interface CSVColumn {
  name: string;
  index: number;
  sampleData: string[];
}

export interface ParsedCSV {
  columns: CSVColumn[];
  rows: string[][];
  rawData: string;
}

export const parseCSV = (csvContent: string): ParsedCSV => {
  const lines = csvContent.split('\n').filter(line => line.trim());

  if (lines.length === 0) {
    throw new Error('CSV file is empty');
  }

  const headers = parseCSVLine(lines[0]);
  const rows: string[][] = [];

  for (let i = 1; i < lines.length; i++) {
    const row = parseCSVLine(lines[i]);
    if (row.length > 0 && row.some(cell => cell.trim())) {
      rows.push(row);
    }
  }

  const columns: CSVColumn[] = headers.map((name, index) => ({
    name: name.trim(),
    index,
    sampleData: rows.slice(0, 3).map(row => row[index] || '').filter(Boolean)
  }));

  return {
    columns,
    rows,
    rawData: csvContent
  };
};

const parseCSVLine = (line: string): string[] => {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current);
  return result;
};

export const downloadSampleCSV = (type: 'students' | 'parents' | 'community' | 'fees' | 'courses') => {
  let csv = '';

  if (type === 'students') {
    csv = `First Name,Last Name,Student ID,Email,Phone,Grade Level,Date of Birth,Address,City,State,Zip Code
John,Doe,12345,john.doe@example.com,555-0101,9,2008-05-15,123 Main St,Springfield,IL,62701
Jane,Smith,12346,jane.smith@example.com,555-0102,10,2007-08-22,456 Oak Ave,Springfield,IL,62702`;
  } else if (type === 'parents') {
    csv = `First Name,Last Name,Email,Phone,Address,City,State,Zip Code,Emergency Contact
Robert,Johnson,r.johnson@example.com,555-0201,789 Pine St,Springfield,IL,62703,Yes
Mary,Williams,m.williams@example.com,555-0202,321 Elm St,Springfield,IL,62704,Yes`;
  } else if (type === 'community') {
    csv = `First Name,Last Name,Email,Phone,Organization,Role
David,Brown,d.brown@example.com,555-0301,Local Business,Volunteer
Sarah,Davis,s.davis@example.com,555-0302,Community Center,Staff`;
  } else if (type === 'fees') {
    csv = `Name,Description,Amount,Category,Due Date,Is Required,Allow Multiple,Max Quantity
Student Activity Fee,Annual activity fee for all students,50.00,School Fees,2024-09-01,Yes,No,1
Yearbook,2024-2025 School Yearbook,25.00,Publications,2024-12-15,No,Yes,2
Field Trip Fee,Transportation and admission for field trips,35.00,Activities,2024-10-01,No,Yes,5`;
  } else if (type === 'courses') {
    csv = `Name,Description,Instructor,Capacity,Schedule,Location,Start Date,End Date
Advanced Mathematics,Advanced math for high school students,Dr. Smith,30,Mon/Wed/Fri 9:00-10:00,Room 101,2024-09-01,2024-12-15
Creative Writing,Introduction to creative writing,Ms. Johnson,25,Tue/Thu 11:00-12:30,Room 205,2024-09-01,2024-12-15
Physics Lab,Hands-on physics laboratory,Prof. Brown,20,Mon/Wed 2:00-4:00,Science Lab,2024-09-01,2024-12-15`;
  }

  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `sample-${type}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};
